<template>
  <div class="block">
    <h3>{{title}}</h3>
    <div :class="'block-body ' + (type=='bgr'?'block-body-right':'')">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "block",
  props:{
    title: String,
    type: String //bgr  bgl
  }
}
</script>

<style lang="less">
  .block{
    h3 {
      line-height: 87px;
      background: url(../assets/img/shangfeng.png) center bottom no-repeat;
      text-align: center;
      font-size: 24px;
      font-weight: 400;
    }
    .block-body {
      overflow: hidden;
      background: url(../assets/img/shangfeng_left.png) 0 top no-repeat;
    }
    .block-body-right {
      background: url(../assets/img/shangfeng_right.png) 100% top no-repeat;
    }
  }
</style>
